import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export const Logo = ({ dark = false, className = "" }) => (
  <Link to="/" className={`inline-flex items-center ${className}`} data-testid="site-logo" aria-label="Car To Cash — home">
    <img
      src={logo}
      alt="Car To Cash"
      width={220}
      height={122}
      className="h-12 w-auto sm:h-14"
    />
  </Link>
);
